import { Alert } from '@seeqdev/qomponents';

import { useTranslation } from 'react-i18next';

interface NoStatisticsSummaryViewProps {
  displayText: string;
}

export const NoStatisticsSummaryView: React.FunctionComponent<NoStatisticsSummaryViewProps> = ({ displayText }) => {
  const { t } = useTranslation();
  return (
    <Alert dismissible={false} variant="theme" extraClassNames="flexSelfCenter fs16 p25 max-width-400">
      {t(displayText)}
    </Alert>
  );
};
